export enum PaysafeEventType {
  Blur = 'Blur',
  FieldValueChange = 'FieldValueChange',
  Focus = 'Focus',
  Invalid = 'Invalid',
  InvalidCharacter = 'InvalidCharacter',
  Valid = 'Valid',
}
